<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="42.5%"
    @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item v-for="(item, index) of formData" :key="index" 
        :label="item.label">
        <a-input v-if="item.type === 'input'" v-decorator="[item.name, { rules: item.rules }]"/>
        <div v-if="item.type === 'upload'" style="display: inline-block; position: relative;" @click="showImagesModal(item.name)">
          <div v-if="imageUrl">
            <LImg :src="imageUrl" style="width: 100px; height: 100px;"/>
            <div class="close" @click="closeImg($event)">&times;</div>
          </div>
          <a-button v-else type="dashed" icon="file-image">选择图片</a-button>
        </div>
        <a-upload v-if="item.type === 'upload2'" v-decorator="[item.name, { rules: item.rules }]" name="file"
          :data="uploadParams"
          :action="uploadUrl" 
          :beforeUpload="beforeUpload"
          :defaultFileList="fileList2"
          accept="video/*"
          @change="changeFile2">
          <a-button>
            <a-icon type="upload" /> 点击上传
          </a-button>
        </a-upload>
        <a-date-picker v-if="item.type === 'date'" style="width: 100%"  v-decorator="[item.name, { rules: item.rules }]" format="YYYY-MM-DD"/>
        <a-select v-else-if="item.type === 'select'" placeholder="请选择"
           v-decorator="[item.name, { rules: item.rules }]">
          <a-select-option v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-select-option>
        </a-select>
        <a-textarea v-else-if="item.type === 'textarea'" :rows="4"
           v-decorator="[item.name, { rules: item.rules }]"/>
        <l-editor v-else-if="item.type === 'textarea2'" name="package_description" :data="package_description"/>
      </a-form-item>
    </a-form>
    <ImageModal v-if="imagesVisible"/>
  </a-modal>
</template>

<script>
const formData = [
  {
    name: 'knowledge_cover',
    label: '内容封面(尺寸 750*360)',
    type: 'upload',
    rules: [{ required: true, message: '请输入专栏封面!' }]
  },
  {
    name: 'title',
    label: '内容标题',
    type: 'input',
    rules: [{ required: true, message: '请输入内容标题!' }]
  },
  // {
  //   name: 'price',
  //   label: '付费价格',
  //   type: 'input',
  //   rules: [{ required: true, message: '请输入付费价格!' }]
  // },
  // {
  //   name: 'sort',
  //   label: '优先度',
  //   type: 'input',
  //   rules: []
  // },
  // {
  //   name: 'course_cate_id',
  //   label: '关联科目',
  //   type: 'select',
  //   rules: [],
  //   items: {
  //     data: 'classCategorys',
  //     label: 'filter_name',
  //     value: 'course_cate_id'
  //   }
  // },
  {
    name: 'content_video',
    label: '视频内容',
    type: 'upload2',
    rules: [{ required: true, message: '请上传视频内容!' }]
  },
  {
    name: 'content',
    label: '内容简介',
    type: 'textarea2',
    rules: []
  },
]
import url from '@/utils/URL'
import ImageModal from '@/views/modal/images'
import createFilePath from '@/utils/tools'
export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    item: Object
  },
  provide() {
    return {
      parent: this
    }
  },
  components: {
    ImageModal,
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      ModalTitle: '新增内容',
      visible: false,
      confirmLoading: false,
      formData,
      form: this.$form.createForm(this),
      seleteItems: {
        classCategorys: []
      },
      
      imageUrl: '',
      imageRoot: url.imageRoot,
      uploadParams: {},
      imagesVisible: false,
      imageKey: '',

      uploadUrl: url.uploadQiNiu, 
      fileList2: [],
      
      package_description: '',
      editor: {},
    }
  },

  async created() {
    this.visible = true
    await this.$nextTick()
    await this.getClassCategory()
    if (this.item) {
      this.ModalTitle = '编辑内容'
      let { item } = this
      let formFields = {}
      for (let d of formData) {
        formFields[d.name] = item[d.name]
      }
      this.imageUrl = item.package_cover
      this.package_description = item['package_description']
      this.form.setFieldsValue(formFields)
    }
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    async getClassCategory() {
      let res = await this.$store.dispatch('searchCourseTypeAction', {})
      this.seleteItems.classCategorys = res.data
    },
    changeEditor(key, value) {
      this.editor[key] = value
    },
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { item, form } = this
        let params = await form.validateFields()
        if (params) {
          if (item) {
            params.content_id = item.content_id
          }
          if (this.fileList2.length) {
            let arr = []
            for (let file of this.fileList2) {
              if (file.response.key) {
                arr.push(file.response.key)
                params.content_video = file.response.key
                params.video_size = file.size
              }
            }
            // params.content_video = arr[0]
          }
          params.knowledge_cover = this.imageUrl
          params.content = this.editor.package_description
          params.knowledge_type = 2
          let res = await this.$store.dispatch(item ? 'knowledgeContentUpdateAction' : 'knowledgeContentAddAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.hideEditModal2(1)
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideEditModal2(0)
    },
    closeImg(e) {
      e.stopPropagation()
      this.imageUrl = ''
    },
    showImagesModal(imageKey) { 
      this.imageKey = imageKey
      this.imagesVisible = true
    },
    hideImagesModal(image) {
      if (image) {
        this.imageUrl = image.path
      }
      this.imagesVisible = false
    },
    async beforeImageUpload(file) {
      if (!file) { return false }
      let res = await this.$store.dispatch('imageTokenAction', {})
      if (res) {
        this.uploadParams.token = res.data.uptoken
        this.uploadParams.key = createFilePath(file.name)
        return true
      }
      return false
    },
    async beforeUpload(file) {
      if (!file) { return false }
      let res = await this.$store.dispatch('massTokenAction', {})
      if (res) {
        this.uploadParams.token = res.data.uptoken
        this.uploadParams.key = createFilePath(file.name)
        return true
      }
      return false
    },
    changeFile2({ file, fileList }) {
      this.fileList2 = fileList
      console.log(fileList)
    },
  }
}
</script>
